import React from "react";
import MainLayout from "../../Layout/mainLayout";
import { ReactComponent as AddTeamIcon } from "./Team Icons/Add Team Icon.svg";
import { Link } from "react-router-dom";
import "./addTeam.css";

const EditTeamMember = () => {
  return (
    <MainLayout>
      <div className="overall-container-grid">
        <div
          style={{
            display: "flex",
            gridColumn: "span 2",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className="top-bar">
            <AddTeamIcon></AddTeamIcon>
            <h1>Add Team Member</h1>
          </div>
          <Link to="/team">
            <button className="view-team-list">View Team List</button>
          </Link>
        </div>
        <h3 style={{ gridColumn: "span 2" }}>Enter Team Member Details</h3>

        <div
          style={{
            gridColumn: "span 1",
            gridRow: "span 2",
            boxSizing: "border-box",
          }}
        >
          <span
            className="span-class"
            style={{
              display: "block",
              position: "relative",
              background: "white",
              top: "4.5%",
              padding: "0px 4px",
              left: "3%",
              width: "max-content",
            }}
          >
            Upload Profile<span style={{ color: "red" }}>*</span>
          </span>
          <input
            className="input-class"
            style={{
              display: "none",
            }}
            type="file"
            id="image"
            name="image"
          />
          <label htmlFor="image">Click to Upload Image</label>
        </div>
        <div>
          <span className="span-class">
            Name<span style={{ color: "red" }}>*</span>
          </span>
          <input className="input-class" type="text" name="name" />
        </div>
        <div>
          <span className="span-class">
            Email<span style={{ color: "red" }}>*</span>
          </span>
          <input className="input-class" type="text" />
        </div>
        <div>
          <span className="span-class">
            Country Code<span style={{ color: "red" }}>*</span>
          </span>
          <input className="input-class" type="text" name="country code" />
        </div>
        <div>
          <span className="span-class">
            Phone Number<span style={{ color: "red" }}>*</span>
          </span>
          <input className="input-class" type="text" name="phone_number" />
        </div>
        <div>
          <span className="span-class">
            Role<span style={{ color: "red" }}>*</span>
          </span>
          <input className="input-class" type="text" name="role" />
        </div>
        <div>
          <span className="span-class">
            Designation<span style={{ color: "red" }}>*</span>
          </span>
          <input className="input-class" type="text" name="designation" />
        </div>
        <div>
          <span className="span-class">
            Department<span style={{ color: "red" }}>*</span>
          </span>
          <input className="input-class" type="text" name="department" />
        </div>
        <div>
          <span className="span-class">
            Timezone<span style={{ color: "red" }}>*</span>
          </span>
          <input className="input-class" type="text" name="timezone" />
        </div>
        <div>
          <span className="span-class">
            Gender<span style={{ color: "red" }}>*</span>
          </span>
          <input className="input-class" type="text" name="gender" />
        </div>
        <div>
          <span className="span-class">
            Date of Birth<span style={{ color: "red" }}>*</span>
          </span>
          <input className="input-class" type="text" name="date-of-birth" />
        </div>
        <div>
          <span className="span-class">
            Joining Date<span style={{ color: "red" }}>*</span>
          </span>
          <input className="input-class" type="text" name="joinin-date" />
        </div>
        <div>
          <span className="span-class">
            Qualification<span style={{ color: "red" }}>*</span>
          </span>
          <input className="input-class" type="text" name="qualification" />
        </div>
        <div>
          <span className="span-class">
            Password<span style={{ color: "red" }}>*</span>
          </span>
          <input className="input-class" type="password" name="password" />
        </div>
        <div>
          <span className="span-class">
            Confirm Password<span style={{ color: "red" }}>*</span>
          </span>
          <input className="input-class" type="text" name="country code" />
        </div>
        <div className="address-document-container">
          <div style={{ width: "50%" }}>
            <h3 style={{ gridColumn: "span 2" }}>Address Details</h3>
            <div className="address-details">
              <div>
                <div>
                  <span className="span-class">
                    Street Address<span style={{ color: "red" }}>*</span>
                  </span>
                  <input
                    className="input-class"
                    type="text"
                    name="country code"
                  />
                </div>
                <div style={{ gridColumn: "span 1" }}>
                  <span className="span-class">
                    Country<span style={{ color: "red" }}>*</span>
                  </span>
                  <input
                    className="input-class"
                    type="text"
                    name="country code"
                  />
                </div>
                <div>
                  <span className="span-class">
                    State<span style={{ color: "red" }}>*</span>
                  </span>
                  <input
                    className="input-class"
                    type="text"
                    name="country code"
                  />
                  <span className="span-class">
                    Zip Code<span style={{ color: "red" }}>*</span>
                  </span>
                  <input
                    className="input-class"
                    type="text"
                    name="country code"
                  />
                </div>
              </div>
            </div>
          </div>
          <div style={{ width: "50%" }}>
            <h3>Documents Details</h3>
            <div className="documents-details">
              <div>
                <div>
                  <span className="span-class">
                    Street Address<span style={{ color: "red" }}>*</span>
                  </span>
                  <input
                    className="input-class"
                    type="text"
                    name="country code"
                  />
                </div>
                <div style={{ gridColumn: "span 1" }}>
                  <span className="span-class">
                    Country<span style={{ color: "red" }}>*</span>
                  </span>
                  <input
                    className="input-class"
                    type="text"
                    name="country code"
                  />
                </div>
                <div>
                  <span className="span-class">
                    State<span style={{ color: "red" }}>*</span>
                  </span>
                  <input
                    className="input-class"
                    type="text"
                    name="country code"
                  />
                  <span className="span-class">
                    Zip Code<span style={{ color: "red" }}>*</span>
                  </span>
                  <input
                    className="input-class"
                    type="text"
                    name="country code"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{ gridColumn: "span 2", paddingTop: "50px" }}
          className="bank-details"
        >
          <div>
            <h3 style={{ gridColumn: "span 2" }}>Bank Details</h3>
            <div className="address-details">
              <div>
                <div>
                  <span className="span-class">
                    Account Number<span style={{ color: "red" }}>*</span>
                  </span>
                  <input
                    className="input-class"
                    type="text"
                    name="country code"
                  />
                </div>
                <div style={{ gridColumn: "span 1" }}>
                  <span className="span-class">
                    Re-Enter Account Number
                    <span style={{ color: "red" }}>*</span>
                  </span>
                  <input
                    className="input-class"
                    type="text"
                    name="country code"
                  />
                </div>
                <div>
                  <span className="span-class">
                    IFSC Code<span style={{ color: "red" }}>*</span>
                  </span>
                  <input
                    className="input-class"
                    type="text"
                    name="country code"
                  />
                  <span className="span-class">
                    Account Holder Name<span style={{ color: "red" }}>*</span>
                  </span>
                  <input
                    className="input-class"
                    type="text"
                    name="country code"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            gridColumn: "2/2",
            alignSelf: "end",
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
          }}
        >
          <button className="button-class">Save</button>
          <button className="button-class-white">Cancel</button>
        </div>
      </div>
    </MainLayout>
  );
};

export default EditTeamMember;
